module.exports = __webpack_public_path__ + "peter_schulz_round-454ef4b62061f838c5d710afc971dd9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/dk/peter_schulz_round.jpg
// module id = 1169
// module chunks = 1 2